@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: dark from "../../styles/theming.module.css";
}

.left,
.right,
.center,
.bottom {
    composes: root;
}

.content {
    --padding: var(--spacer-48);

    gap: var(--spacer-8);

    .left & {
        padding-left: var(--padding);
    }

    .right & {
        padding-right: var(--padding);
    }

    .bottom & {
        padding-block: var(--padding);
    }
}

.media {
    .left & {
        --rotate: -90deg;
    }

    .right & {
        --rotate: 90deg;
    }

    .bottom & {
        --rotate: 180deg;
    }

    &::after {
        content: "";
        position: absolute;
        inset: 0;

        :is(.left, .right, .bottom) & {
            background: linear-gradient(
                var(--rotate),
                rgb(var(--true-black-base) / 0%) 0%,
                rgb(var(--true-black-base) / 100%) 100%
            );
        }
    }
}

.carousel {
    position: relative;

    @media ($below-mobile) {
        & .content {
            --padding: var(--spacer-104);
        }
    }
}

.carouselTabList {
    --color-contrast: var(--white);

    position: absolute;
    bottom: var(--spacer-24);
    width: 100%;
    justify-content: center;
    translate: 0;
    z-index: 1;
    gap: 0;
}

.carouselTab {
    position: relative;
    width: 16px;
    height: 16px;
    background-color: transparent;

    &::before {
        content: "";
        position: absolute;
        inset: 4px;
        background-color: var(--color-contrast);
        border-radius: 4px;
    }

    &:not([aria-selected]) {
        opacity: 1;

        &::before {
            inset: 5px;
            opacity: 0.7;
        }
    }
}

.carouselTabPanel {
    vertical-align: top;
}

.carouselNav {
    --color-contrast: var(--white);
    --margin: calc(var(--labui-container-margin));

    position: absolute;
    inset: auto var(--margin) var(--spacer-48);
    display: flex;
    justify-content: space-between;

    @media ($below-mobile) {
        display: none;
    }
}

.navArrow {
    width: var(--spacer-40);
    height: var(--spacer-40);
}
